import { H1, H2, H3, H4, H5, H6 } from "./styles";

export const Heading = (props) => {
    const { level } = props

    const getHeading = () => {
        switch(level) {
            case 1:
                return <H1 style={props.style}>{props.children}</H1>
            case 2:
                return <H2 style={props.style}>{props.children}</H2>
            case 3:
                return <H3 style={props.style}>{props.children}</H3>
            case 4:
                return <H4 style={props.style}>{props.children}</H4>
            case 5:
                return <H5 style={props.style}>{props.children}</H5>
            case 6:
                return <H6 style={props.style}>{props.children}</H6>
            default:
                break;
        }
    }

    return <>{ getHeading() }</>
}